/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Chat_Input_Chip1_LabelInputs */



/**
* | output |
* | --- |
* | "What can I do from here?" |
*
* @param {Uno_Edu_Chat_Input_Chip1_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_chat_input_chip1_label = /** @type {((inputs?: Uno_Edu_Chat_Input_Chip1_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Chat_Input_Chip1_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was kann ich hier tun?")
	return /** @type {LocalizedString} */ ("What can I do from here?")
});